import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=21469110"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"
import style0 from "./offers.vue?vue&type=style&index=0&id=21469110&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports